"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");
/**
 * A comunica RDF Metadata Extract Actor for SPARQL service descriptions.
 */


var ActorRdfMetadataExtractSparqlService =
/*#__PURE__*/
function (_bus_rdf_metadata_ext) {
  _inherits(ActorRdfMetadataExtractSparqlService, _bus_rdf_metadata_ext);

  function ActorRdfMetadataExtractSparqlService(args) {
    _classCallCheck(this, ActorRdfMetadataExtractSparqlService);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfMetadataExtractSparqlService).call(this, args));
  }

  _createClass(ActorRdfMetadataExtractSparqlService, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  // Forward errors
                  action.metadata.on('error', reject); // Immediately resolve when a SPARQL service endpoint URL has been found

                  action.metadata.on('data', function (quad) {
                    if (quad.predicate.value === 'http://www.w3.org/ns/sparql-service-description#endpoint' && quad.subject.value === action.url) {
                      resolve({
                        metadata: {
                          sparqlService: quad.object.value
                        }
                      });
                    }
                  }); // If no value has been found, emit nothing.

                  action.metadata.on('end', function () {
                    resolve({
                      metadata: {}
                    });
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorRdfMetadataExtractSparqlService;
}(bus_rdf_metadata_extract_1.ActorRdfMetadataExtract);

exports.ActorRdfMetadataExtractSparqlService = ActorRdfMetadataExtractSparqlService;